import React from "react";
import NavLink from "../components/NavLink";
import "../styles/lesson.css";
import ContentLoader from "../components/ContentLoader";
import ReactHtmlParser from "react-html-parser";
import { defaultLang } from '../components/common/Constants';
import {translate} from '../containers/i18n';

class Lesson extends React.Component {
  constructor(props) {
    super(props);

    this.onLoadComplete = this.onLoadComplete.bind(this);
    this.updateLessonContent = this.updateLessonContent.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);

    this.state = {
      htmlContent: null,
      height: window.innerHeight,
      width: window.innerWidth
    };
  }

  updateDimensions() {
    this.setState(
      {
        height: window.innerHeight,
        width: window.innerWidth
      },
      () => this.updateLessonContent()
    );
  }

  updateLessonContent() {
    const d = document.getElementById("lesson");

    if (d) {
      const h = this.state.htmlContent ? d.clientHeight + 512 : 1000;
      if (this.props.updateContainerHeight) this.props.updateContainerHeight(h);
    } else {
      setTimeout(this.updateLessonContent, 150);
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
  }

  onLoadComplete(data) {
    const page = ReactHtmlParser(data);
    this.setState({ htmlContent: page });
  }

  render() {
    if (this.props.lessonId) {
      const content = this.state.htmlContent;
      this.updateLessonContent();

      return (
        <ContentLoader id={this.props.lessonId} lang={this.props.lang} url={(this.props.lang || defaultLang) +"/lessons/"} onComplete={this.onLoadComplete}>
          <div id="lesson" className="lesson">
            {content && <article>{content}</article>}
            <div className="backLessonButton">
              <NavLink to="../../../programmation">{this.props.t("backMenu")}</NavLink>
            </div>
          </div>
        </ContentLoader>
      );
    } else {
      const menuP = this.props.menu.subMenu || [];
      this.updateLessonContent();
      return (
        <>
          <hr className="stars"/>
          <div id="lesson" className="lesson_menu">
            <div>{this.props.t("menu4item0")}</div>
            <nav className="subnav">
              <div className="menu">
                {menuP.map(item => {
                  return (
                    <NavLink key={item.label} to={item.path}>
                      <div key={item.label} className="menuItem">
                        {item.label}
                      </div>
                    </NavLink>
                  );
                })}
              </div>
            </nav>
            <hr className="stars"/>
          </div>
        </>
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }
}

export default translate(Lesson);
